import { getState, on, setState, subscribe } from './app/store'

/**
 * Mobile navigation: below the medium breakpoint the nav list is a
 * full-screen overlay, opened by the pixel pizza slice in the header bar.
 * While it is open the page, footer and chat window are inert, so focus stays
 * inside. An open chat sits above the header (z-index) and would cover the
 * overlay's entries, so the CSS also hides it until the overlay closes.
 * On larger screens the list is the regular header bar and this stays idle.
 */
const MOBILE = window.matchMedia('(max-width: 639px)')

const inertTargets = () => [
  document.querySelector('#swup'),
  document.querySelector('.site-footer'),
  document.querySelector('[data-chat-window]'),
]

function render(open) {
  const toggle = document.querySelector('[data-nav-toggle]')
  toggle?.setAttribute('aria-expanded', String(open))
  inertTargets().forEach((element) => {
    if (element) element.inert = open
  })

  if (open) {
    document.querySelector('[data-nav] a, [data-nav] button')?.focus()
  } else if (toggle && document.activeElement?.closest('[data-nav]')) {
    toggle.focus()
  }
}

export function startMobileNav() {
  const close = () => setState({ navOpen: false })

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-nav-toggle]')) {
      setState({ navOpen: !getState().navOpen })
    } else if (getState().navOpen && event.target.closest('[data-nav] a, [data-nav] button')) {
      // A link starts a visit, "chat" opens the chat — either way the overlay goes.
      close()
    }
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !getState().navOpen) return
    // Handled: the chat (js/chat.js) leaves this Escape alone.
    event.preventDefault()
    close()
  })

  // Rotating to landscape / resizing past the breakpoint leaves no overlay behind.
  MOBILE.addEventListener('change', (event) => {
    if (!event.matches) close()
  })

  on('page-view', close)

  subscribe((state, changed) => {
    if (changed.includes('navOpen')) render(state.navOpen)
  })
}
